export default __webpack_public_path__ + "static/media/pic4.505e9e89.jpg";